import React, { useRef, useEffect } from 'react';
import { X } from 'lucide-react';

export function InfoModal({ open, onClose, order }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 2000 }}>
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="bg-white rounded-2xl w-full max-w-md max-h-[80vh] overflow-y-auto relative">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Información</h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <p className="text-sm font-semibold text-gray-500 mb-1">Dirección</p>
            <p className="text-gray-900">{order?.address || 'No especificada'}</p>
          </div>
          {order?.store_name && (
            <div>
              <p className="text-sm font-semibold text-gray-500 mb-1">Tienda</p>
              <p className="text-gray-900">{order.store_name}</p>
            </div>
          )}
          {order?.order_notes && (
            <div>
              <p className="text-sm font-semibold text-gray-500 mb-1">Notas del Pedido</p>
              <p className="text-gray-900">{order.order_notes}</p>
            </div>
          )}
          <div>
            <p className="text-sm font-semibold text-gray-500 mb-1">Cliente</p>
            <p className="text-gray-900">{order?.customer_name}</p>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-500 mb-1">Teléfono</p>
            <p className="text-gray-900">{order?.telefono}</p>
          </div>
        </div>
      </div>
    </div>
  );
}